import { Link } from "react-router-dom";
import { Code, Mail } from "lucide-react";
import { Separator } from "@/components/ui/separator";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="bg-[#0B1220] text-white">
      <div className="mx-auto w-full max-w-[var(--container-max)] px-4 sm:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 lg:gap-12">
          {/* Brand Column */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-5">
              <div className="w-9 h-9 rounded-xl bg-[#1677FF] flex items-center justify-center">
                <Code className="w-5 h-5 text-white" />
              </div>
              <div className="flex flex-col">
                <span className="text-lg font-bold leading-tight tracking-tight" style={{ fontFamily: "var(--font-display)" }}>
                  Maple Code
                </span>
                <span className="text-[10px] font-semibold text-white/60 tracking-widest uppercase leading-tight">
                  Academy
                </span>
              </div>
            </Link>
            <p className="text-sm text-white/60 leading-relaxed mb-4 lg:mb-[36px]">
              We help children explore the world of coding, robotics, and digital creativity through engaging, hands-on learning experiences.
            </p>
            <div className="flex items-center gap-2 mb-6">
              <Mail className="w-4 h-4 text-[#1677FF] flex-shrink-0" />
              <a href="mailto:info@maplecodeacademy.ca" className="text-sm text-white/70 hover:text-white transition-colors">
                info@maplecodeacademy.ca
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="lg:ml-auto">
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/40 mb-5" style={{ fontFamily: "var(--font-display)" }}>Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-sm text-white/70 hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-sm text-white/70 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/programs" className="text-sm text-white/70 hover:text-white transition-colors">Programs</Link></li>
              <li><Link to="/contact" className="text-sm text-white/70 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div className="lg:ml-auto">
            <h4 className="text-sm font-bold uppercase tracking-wider text-white/40 mb-5" style={{ fontFamily: "var(--font-display)" }}>Legal</h4>
            <ul className="space-y-3">
              <li><Link to="/privacy" data-testid="footer-link-privacy" className="text-sm text-white/70 hover:text-white transition-colors">Privacy Policy</Link></li>
              <li><Link to="/terms" data-testid="footer-link-terms" className="text-sm text-white/70 hover:text-white transition-colors">Terms of Use</Link></li>
              <li><Link to="/cookies" data-testid="footer-link-cookies" className="text-sm text-white/70 hover:text-white transition-colors">Advertising & Cookies</Link></li>
            </ul>
          </div>

        </div>

        <Separator className="my-10 bg-white/10" />

        <div className="flex items-center justify-center">
          <p className="text-xs text-white/40">
            &copy; {new Date().getFullYear()} Maple Code Academy. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
